// Dona de distribución (SVG, sin dependencias). `segments`: [{ name, n, pct }].
import { useTheme } from '@mui/material/styles';

const DonutChart = ({ segments = [], colors = [], size = 190 }) => {
  const theme = useTheme();
  const stroke = 30;
  const r = (size - stroke) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const C = 2 * Math.PI * r;

  const total = segments.reduce((s, seg) => s + (seg.pct || 0), 0) || 100;
  let acumulado = 0;

  return (
    <svg viewBox={`0 0 ${size} ${size}`} width={size} height={size}>
      <circle cx={cx} cy={cy} r={r} fill="none" stroke={theme.palette.sutil} strokeWidth={stroke} />
      {segments.map((seg, i) => {
        const frac = (seg.pct || 0) / total;
        const dash = frac * C;
        const el = (
          <circle
            key={i}
            cx={cx} cy={cy} r={r}
            fill="none"
            stroke={colors[i % colors.length]}
            strokeWidth={stroke}
            strokeDasharray={`${dash} ${C - dash}`}
            strokeDashoffset={-acumulado}
            transform={`rotate(-90 ${cx} ${cy})`}
          />
        );
        acumulado += dash;
        return el;
      })}
    </svg>
  );
};

export default DonutChart;
